import {
  CardDescription,
  CardTitle,
} from "@cointervue/design-system/components";
import { ClockIcon, LocationIcon } from "@assets/Icons";
import type { JobCardDescriptionProps } from "./types";

export default function JobCardDescription({
  description = "No description available.",
  location,
  createdAt,
  experience,
}: JobCardDescriptionProps) {
  return (
    <>
      <div className="flex flex-col sm:flex-row gap-1.5 sm:gap-4">
        <CardDescription className="flex gap-1 items-center text-wrap break-words sm:text-nowrap">
          <img src={LocationIcon} alt="Job location" className="h-5 w-5 shrink-0" />
          {location}
        </CardDescription>
        <CardDescription className="flex gap-1 items-center shrink-0">
          <img src={ClockIcon} alt="Posted date" className="h-5 w-5 shrink-0" />
          {new Date(createdAt).toLocaleDateString()}
        </CardDescription>
      </div>
      <CardDescription className="flex mt-2">
        Experience: &nbsp;
        <CardTitle className="font-medium">
          {experience?.minimum ?? 0} - {experience?.maximum ?? 0} years
        </CardTitle>
      </CardDescription>
      <CardDescription className="line-clamp-2 mt-2">
        {description}
      </CardDescription>
    </>
  );
}
